export type ID = string;

export interface DataSnapshot {
  version: number;
  tenant: { id: ID; name: string; plan: 'Free' | 'Pro' | 'Enterprise'; seats: number } | null;
  users: Array<{
    id: ID;
    tenantId: ID;
    name: string;
    email: string;
    role: 'admin' | 'lawyer' | 'paralegal' | 'staff';
  }>;
  clients: Array<{
    id: ID;
    tenantId: ID;
    name: string;
    email?: string;
    phone?: string;
    company?: string;
    mrr?: number;
    billingStatus?: 'On-Time' | 'Late' | 'Paused';
    healthScore?: number;
    createdAt: string;
  }>;
  cases: Array<{
    id: ID;
    tenantId: ID;
    clientId: ID;
    title: string;
    status: 'investigation' | 'pre-trial' | 'in-court' | 'closed';
    priority: 'low' | 'med' | 'high';
    nextDate?: string;
    progress?: number;
    createdAt: string;
  }>;
  whiteboards: Array<{
    id: ID;
    tenantId: ID;
    title: string;
    clientId?: ID;
    caseId?: ID;
    template?: 'blank' | 'strategy' | 'evidence' | 'contract';
    createdAt: string;
    content?: unknown;
  }>;
}

export const CURRENT_SCHEMA = 1;
